import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";

import AllMaterial from "./AllMaterial";
import TimeLineLogRightbar from "../TimeLineLogRightbar";

import FiltertRightbar from "../FiltersRightbar";
import {
  SetParams,
  getServiceReqList,
  // getServiceReqListcount,
  FiltersShowRightSidebar,
  FilterClear,
  SRSelecteChangeValue,
  clearData,
} from "../../../store/ServiceRequest/actions";

import { getUserDepartment } from "../../../store/Mini/actions";

import "../../../assets/scss/dashboard.scss";

import LoadingModel from "../../LoadingModel";

class ServiceRequestDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      FilterToggle: false,
      dropdownOpen: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  getMRlist(tab) {
    // var srstatus = [0];
    // if (tab === 1) {
    //   srstatus = [0];
    // } else {
    //   if (tab === 5) {
    //     srstatus = [5, 7, 8];
    //   } else {
    //     srstatus = [tab];
    //   }
    // }
    this.setState({ activeTab: tab });
    var srstatus = [0];
    var pistatus = [0];
    var mistatus = [0];
    if (tab === 1) {
      // All
      srstatus = [0];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 2) {
      // SR Pending
      srstatus = [3];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 3) {
      // SR Approved
      srstatus = [5, 9, 10, 11, 12];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 4) {
      // SR Rejected
      srstatus = [6];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 5) {
      //  PI Pending
      srstatus = [5, 9, 10, 11, 12];
      pistatus = [1, 2];
      mistatus = [0];
    } else if (tab === 6) {
      // PI Completed
      srstatus = [5, 9, 10, 11, 12];
      pistatus = [3];
      mistatus = [0];
    } else if (tab === 7) {
      // PI Pending
      srstatus = [5, 9, 10, 11, 12];
      pistatus = [0];
      mistatus = [1, 2, 3];
    } else if (tab === 8) {
      //  PI Completed
      srstatus = [5, 9, 10, 11, 12];
      pistatus = [0];
      mistatus = [4];
    } else if (tab === 9) {
      //  PI Completed
      srstatus = [0];
      pistatus = [0];
      mistatus = [5];
    }
    this.props.SetParams({
      ...this.props.params,
      srstatus: srstatus,
      pistatus: pistatus,
      mistatus: mistatus,
      page: 1,
    });
    this.props.getServiceReqList({
      ...this.props.params,
      srstatus: srstatus,
      pistatus: pistatus,
      mistatus: mistatus,
      page: 1,
    });
  }
  componentDidMount() {
    this.setState({ activeTab: 1 });
    this.props.FilterClear();
    this.props.clearData();

    // this.props.getServiceReqListcount();
    this.props.SetParams({
      ...this.props.params,
      srstatus: [0],
      pistatus: [0],
      mistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      departments: "",
      sritems__product: "",
    });
    this.props.getServiceReqList({
      ...this.props.params,
      srstatus: [0],
      pistatus: [0],
      mistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      departments: "",
      sritems__product: "",
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content ">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            <Row>
              <Col lg={12}>
                <Card className="pagebody">
                  <CardHeader className="bg-transparent pb-0">
                    <div className="d-inline-block">
                      <h5 className="card-title-18 pt-2 d-flex">
                        <span className="d-none d-lg-block">
                          Service Request
                        </span>
                        <span className="d-lg-none">SR</span>
                        <span className="pl-1"> Dashboard</span>
                      </h5>
                    </div>
                    <div className="float-right d-inline-block">
                      <div className="d-inline-block">
                        <Dropdown
                          isOpen={this.state.dropdownOpen}
                          toggle={this.toggle}
                          className="d-flex mr-2"
                        >
                          <DropdownToggle
                            caret
                            color="primary"
                            className="d-flex mr-2"
                          >
                            <i className="mdi mdi-rotate-right"></i>
                            <span className="d-none d-lg-block ml-1">
                              SR List
                            </span>
                          </DropdownToggle>
                          <DropdownMenu>
                            {/* <DropdownItem header>All</DropdownItem> */}
                            <DropdownItem onClick={() => this.getMRlist(1)}>
                              All
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={() => this.getMRlist(2)}>
                              SR Pending
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(3)}>
                              SR Approved
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(4)}>
                              SR Rejected
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={() => this.getMRlist(5)}>
                              PI Process
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(6)}>
                              PI Completed
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={() => this.getMRlist(7)}>
                              PI Process
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(8)}>
                              PI Completed
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(9)}>
                              PI Closed
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                      <div className="d-inline-block">
                        {/* {" "}
                          <Row className="justify-content-center align-items-center">
                            <Col md={3}>
                              <Label
                                htmlFor="validationCname"
                                className="col-form-label float-right"
                              >
                                Department:
                              </Label>
                            </Col>
                            <Col md={9}>
                              <Select
                                id="Userdepartment_id"
                                name="Userdepartment_id"
                                classNamePrefix="select2-selection "
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                options={this.props.userDeparment.map(
                                  (item, index) => ({
                                    label: item.name,
                                    value: item.id,
                                  })
                                )}
                                value={{
                                  label:
                                    this.props.srRowData?.mrpartmentLabel ==
                                    null
                                      ? this.props.userDeparment[0]?.name
                                      : this.props.srRowData?.mrpartmentLabel,
                                  value:
                                    this.props.srRowData?.mrdepartment_id ==
                                    null
                                      ? this.props.userDeparment[0]?.id
                                      : this.props.srRowData?.mrdepartment_id,
                                }}
                                onChange={(e) => {
                                  this.props.SRSelecteChangeValue({
                                    key: "mrpartmentLabel",
                                    label: e.label,
                                    key2: "mrdepartment_id",
                                    value: e.value,
                                  });
                                  this.props.SetParams({
                                    ...this.props.params,
                                    srstatus: [0],
                                    search: "",
                                    start_date: "",
                                    end_date: "",
                                    userdepartment: "",
                                    departments: e.value,
                                  });
                                  this.props.getServiceReqList({
                                    ...this.props.params,
                                    srstatus: [0],
                                    search: "",
                                    start_date: "",
                                    end_date: "",
                                    userdepartment: "",
                                    departments: e.value,
                                  });
                                  this.props.getServiceReqListcount({
                                    departments: e.value,
                                  });
                                }}
                              />
                            </Col>
                          </Row> */}

                        <Button
                          type="button"
                          color="light"
                          className="waves-effect waves-light d-flex mr-2"
                          onClick={() => {
                            this.setState({ activeTab: 1 });
                            this.props.getServiceReqList({
                              ...this.props.params,
                              srstatus: [0],
                              search: "",
                              start_date: "",
                              end_date: "",
                              userdepartment: "",
                              departments: "",
                            });
                            // this.props.getServiceReqListcount();
                            this.props.SetParams({
                              ...this.props.params,
                              srstatus: [0],
                              search: "",
                              start_date: "",
                              end_date: "",
                              userdepartment: "",
                              departments: "",
                            });
                          }}
                        >
                          <i className="mdi mdi-rotate-right"></i>
                          <span className="d-none d-lg-block ml-1">
                            Refresh
                          </span>
                        </Button>
                      </div>
                      <div className="d-inline-block">
                        <Button
                          type="button"
                          color="light"
                          className="waves-effect waves-light d-flex  mr-2"
                          onClick={() => this.props.FiltersShowRightSidebar(3)}
                        >
                          <i className="mdi mdi-filter"></i>
                          <span className="d-none d-lg-block ml-1">
                            Filters
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0">
                    <Nav tabs className="nav-tabs-custom ">
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: true },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          {this.state.activeTab === 1
                            ? "All "
                            : this.state.activeTab === 2
                            ? "Pending "
                            : this.state.activeTab === 3
                            ? "Approved "
                            : this.state.activeTab === 4
                            ? "Rejected "
                            : this.state.activeTab === 5
                            ? "PI Process "
                            : this.state.activeTab === 6
                            ? "PI Completed "
                            : this.state.activeTab === 7
                            ? "PI Process "
                            : this.state.activeTab === 8
                            ? "PI Completed "
                            : ""}
                          | <span>{this.props.srRowlistcount} </span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent>
                      <AllMaterial activeTab={this.state.activeTab} />
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <FiltertRightbar />
            <TimeLineLogRightbar />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { userDeparment } = state.Mini;
  const { srRowList, srRowlistcount, params, srRowData, loading } =
    state.Servicerequest;
  return {
    srRowList,
    srRowlistcount,
    params,
    userDeparment,
    srRowData,
    loading,
  };
};

export default connect(mapStatetoProps, {
  SetParams,
  getServiceReqList,
  // getServiceReqListcount,
  FiltersShowRightSidebar,
  FilterClear,
  getUserDepartment,
  SRSelecteChangeValue,
  clearData,
})(ServiceRequestDashboard);
